import { render, staticRenderFns } from "./ItemGridView.vue?vue&type=template&id=faf66ea8&scoped=true"
import script from "./ItemGridView.vue?vue&type=script&lang=js"
export * from "./ItemGridView.vue?vue&type=script&lang=js"
import style0 from "./ItemGridView.vue?vue&type=style&index=0&id=faf66ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf66ea8",
  null
  
)

export default component.exports